import Vue from 'vue'
import Vuex from 'vuex'

import user from './module/user'
import app from './module/app'
import tempAct from "./module/tempAct";

import $localStore from 'store'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    //
    locale: $localStore.get('locale') || 'zh-cn',
    publicSideMenu: [],
    showBreadCrumb:true, // 是否显示面包屑导航
  },
  mutations: {
    //
    SETLOCALE(state, locale) {
      $localStore.set('locale', locale);
      state.locale = locale;
    },
    SETPUBLICSIDEMENU(state, publicSideMenu) {
      state.publicSideMenu = publicSideMenu;
    },
    SETSHOWBREADCRUMB(state, show) {
      state.showBreadCrumb = show;
    },
  },
  getters: {
    getLocale: state => state.locale,
    getPublicSideMenu: state => state.publicSideMenu,
    getShowBreadCrumb: state => state.showBreadCrumb,
  },
  actions: {
    //
  },
  modules: {
    user,
    app,
    tempAct,
  }
})



// WEBPACK FOOTER //
// ./src/store/index.js